import { Box, Container, Typography } from "@mui/material";
import React from "react";

const HeroSection = () => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: { xs: "500px", sm: "600px", md: "700px" },
        minHeight: { xs: "500px", sm: "600px", md: "700px" },
      }}
    >
      <Box
        sx={{
          position: "relative",
          height: "100%",
          width: "100%",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            backgroundImage: `url("/websiteAssets/LandingPageHeroSection.png")`,
            backgroundSize: "cover",
            backgroundPosition: { xs: "center", md: "top" },
          }}
        >
          <Box
            sx={{
              height: "100%",
              backgroundColor: "rgba(31, 22, 79, 0.25)",
            }}
          />
        </Box>

        <Container
          maxWidth="lg"
          sx={{
            height: "100%",
            display: "flex",
            alignItems: { xs: "center", md: "flex-start" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              maxWidth: { xs: "100%", md: "666px" },
              gap: { xs: 2, md: "20px" },
              position: "relative",
              pt: { xs: 0, sm: "40px", md: "227px" },
              pl: { xs: 0, md: "100px" },
              ml: { xs: 0, md: "-100px" },
              px: { xs: 2.5, md: 0 },
              textAlign: { xs: "center", md: "left" },
            }}
          >
            <Typography
              variant="h1"
              sx={{
                color: "white",
                whiteSpace: { xs: "normal", md: "nowrap" },
                fontFamily: "'Jost-Bold', Montserrat",
                fontWeight: 700,
                fontSize: { xs: "36px", sm: "48px", md: "60px" },
                lineHeight: "110%",
                letterSpacing: "-1px",
                textShadow: "0px 2px 6px rgba(0,0,0,0.3)",
              }}
            >
              APNA CARD
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 500,
                fontSize: { xs: "14px", sm: "16px", md: "18px" },
                color: "white",
                textShadow: "0px 4px 4px rgba(255, 255, 255, 0.25)",
                lineHeight: { xs: 1.7, md: 1.5 },
              }}
            >
              Apna Card empowers teams and enterprises with a paperless solution
              for lead capture, employee management, medical records, and
              seamless collaboration, driving business growth and stronger
              connections.
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default HeroSection;
